function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.46 283.46"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Train"
}, /*#__PURE__*/React.createElement("path", {
  d: "M227.732 219.706c2.67-1.75 5.15-3.82 7.38-6.16 7.99-8.4 12.24-19.87 11.65-31.45l-5.74-112.67c-.76-15.08-13.2-26.9-28.31-26.9H71.282c-15.11 0-27.55 11.82-28.31 26.9l-5.74 112.67c-.59 11.58 3.65 23.05 11.64 31.45a42.62 42.62 0 007.31 6.12l-44.66 63.8h34.18l10.04-14.35h172.18l9.95 14.35h34.07l-44.21-63.76zm-114.08-148.83h56.68v49.6h-56.68v-49.6zm-38.31 170.24l10.04-14.34h113.18l9.95 14.34H75.342zm139.23-47.09c-2.71 2.84-6.35 4.41-10.28 4.41h-124.6c-3.92 0-7.57-1.57-10.27-4.41-2.7-2.85-4.08-6.57-3.88-10.49l5.74-112.66h14.02v77.95h113.37v-77.95h14.04l5.74 112.66c.2 3.92-1.18 7.64-3.88 10.49zM85.04 0h113.386v28.347H85.04z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: "186.001",
  cy: "171.97",
  rx: "12.42",
  ry: "12.278"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: "97.459",
  cy: "171.97",
  rx: "12.42",
  ry: "12.278"
}))));